import React from "react";
import { Outlet } from "react-router-dom";
import MFooterNavigation from "../ui/atoms/MFooterNavigation";

/**
 * ProfileLayout: Used for 3rd Level Screens.
 * Renders main content
 */
const ProfileLayout: React.FC<
  React.PropsWithChildren<{ hideFooterNav?: true | false }>
> = ({ children, hideFooterNav = false }) => {
  return (
    <div
      className="flex flex-col overflow-hidden"
      style={{ height: "calc(var(--vh, 1vh) * 100)" }}
    >
      {/* Without an explicit height here, `<main>`'s flex-1/min-h-0 has
          nothing to resolve against, so overflow-y-auto never actually
          becomes scrollable — same bounded-height + overflow-y-auto
          pattern as Layout.tsx's <main>, which IS reliably scrollable
          (including once the keyboard resizes the viewport). */}
      <main className="flex-1 min-h-0 flex flex-col overflow-y-auto overflow-x-hidden">
        {children ? children : <Outlet />}
      </main>
      {!hideFooterNav && <MFooterNavigation />}
    </div>
  );
};

export default ProfileLayout;
